import React from 'react'
import { Admin, Resource } from 'react-admin'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar'
import { webantDataProvider, authProvider, russianMessages } from './utils'
import { ListUser, CreateUser, EditUser, ShowUser } from './resources/users'
import { ListClubs, CreateClub, EditClub, ShowClub } from './resources/clubs'
import {
  ListTournaments,
  CreateTournament,
  EditTournament,
  ShowTournament,
} from './resources/tournaments'
import { ListTournamentLevels, ShowTournamentLevel, EditTournamentLevel } from './resources/tournamentLevels'
import { defaultTheme } from 'react-admin'
import merge from 'lodash/merge'
import { lightTheme } from './utils/themes'
import GroupIcon from '@material-ui/icons/Group'
import SportsKabaddiIcon from '@material-ui/icons/SportsKabaddi'
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents'
import { ROLE_ADMIN } from './utils/constants'

const i18nProvider = polyglotI18nProvider(() => russianMessages, 'ru')
const myTheme = merge({}, defaultTheme, lightTheme)

const App = () => (
  <Admin
    dataProvider={webantDataProvider(`${process.env.REACT_APP_BASE_PATH}`)}
    authProvider={authProvider}
    i18nProvider={i18nProvider}
    theme={myTheme}
  >
    {(permissions) => [
      permissions === ROLE_ADMIN ? (
        <Resource name='admins' options={{ label: 'Администраторы' }} list={ListUser} create={CreateUser} edit={EditUser} show={ShowUser} icon={PermContactCalendarIcon} />
      ) : null,
    ]}
    <Resource name='users' options={{ label: 'Пользователи' }} list={ListUser} show={ShowUser} edit={EditUser} create={CreateUser} icon={PermContactCalendarIcon} />
    <Resource name='tournaments' options={{ label: 'Турниры' }} list={ListTournaments} create={CreateTournament} edit={EditTournament} show={ShowTournament} icon={SportsKabaddiIcon} />
    <Resource name='clubs' options={{ label: 'Клубы' }} list={ListClubs} create={CreateClub} edit={EditClub} show={ShowClub} icon={GroupIcon} />
    <Resource name='tournament_levels' options={{ label: 'Рейтинговые баллы' }} list={ListTournamentLevels} edit={EditTournamentLevel} show={ShowTournamentLevel} icon={EmojiEventsIcon} />
    <Resource name='cities' />
    <Resource name='user_tournaments' />
    <Resource name='tournament_categories' />
    <Resource name='participation_requests' />
    <Resource name='membership_requests' />
  </Admin>
)

export default App
